import React from 'react';
import { Chart } from 'react-chartjs-2';
import { useTheme } from '../../contexts/ThemeContext';
import { getChartJsOptions, getChartColors } from '../../utils/themeHelpers';

interface MixedChartProps {
  data: any;
  options?: any;
  height?: number;
  title?: string;
  className?: string;
  type?: 'bar' | 'line';
}

const MixedChart: React.FC<MixedChartProps> = ({
  data,
  options = {},
  height = 320,
  title,
  className = '',
  type = 'bar'
}) => {
  const { currentTheme } = useTheme();

  const defaultOptions = getChartJsOptions(currentTheme);
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    maintainAspectRatio: false,
    responsive: true,
  };

  return (
    <div className={`mixed-chart-container ${className}`}>
      {title && (
        <h3 className="title-card">{title}</h3>
      )}
      <div style={{ height, width: '100%' }}>
        <Chart type={type} data={data} options={mergedOptions} />
      </div>
    </div>
  );
};

export default MixedChart;